import qs from 'qs';
import { toUnderscoreObject } from 'helpers/toUnderscore';
import dotToPath from 'helpers/dotToPath';
import cleanDeep from 'clean-deep';
import { getLanguage } from 'translation';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const consultantsEndpoint = {
  dataURL: 'consultants',
  sourceName: 'consultantsList',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters: { name, ...filtersRest }, sort, search }) => {
    const urlData = {
      filters: toUnderscoreObject(dotToPath({ ...filtersRest, search: name }), false),
      sort
    };

    if (search) {
      urlData.search = search;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const lang = getLanguage().toUpperCase();

    urlData.fields = [
      '_id',
      `firstName${lang}`,
      `lastName${lang}`,
      'location',
      'isWorkOffline',
      'photoLinks',
      'services',
      'experience',
      'experienceFrom'
    ];

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload, state, concat) => {
    const { meta } = payload;
    const { limit, count, offset } = meta || {};

    return {
      data: concat ? (state.data || []).concat(payload) : payload,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count
    };
  }
};

export default consultantsEndpoint;
